// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/force_reload_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ForceReload } from "../../../entity/force_reload_pb";

/**
 * IndexForceReloadArgs メッセージ
 *
 * @generated from message service.IndexForceReloadArgs
 */
export class IndexForceReloadArgs extends Message<IndexForceReloadArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexForceReloadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexForceReloadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexForceReloadArgs {
    return new IndexForceReloadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexForceReloadArgs {
    return new IndexForceReloadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexForceReloadArgs {
    return new IndexForceReloadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexForceReloadArgs | PlainMessage<IndexForceReloadArgs> | undefined, b: IndexForceReloadArgs | PlainMessage<IndexForceReloadArgs> | undefined): boolean {
    return proto3.util.equals(IndexForceReloadArgs, a, b);
  }
}

/**
 * CreateForceReloadArgs メッセージ
 *
 * @generated from message service.CreateForceReloadArgs
 */
export class CreateForceReloadArgs extends Message<CreateForceReloadArgs> {
  /**
   * @generated from field: repeated entity.ForceReload force_reloads = 1 [json_name = "force_reloads"];
   */
  forceReloads: ForceReload[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateForceReloadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateForceReloadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "force_reloads", jsonName: "force_reloads", kind: "message", T: ForceReload, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateForceReloadArgs {
    return new CreateForceReloadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateForceReloadArgs {
    return new CreateForceReloadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateForceReloadArgs {
    return new CreateForceReloadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateForceReloadArgs | PlainMessage<CreateForceReloadArgs> | undefined, b: CreateForceReloadArgs | PlainMessage<CreateForceReloadArgs> | undefined): boolean {
    return proto3.util.equals(CreateForceReloadArgs, a, b);
  }
}

/**
 * ReadForceReloadArgs メッセージ
 *
 * @generated from message service.ReadForceReloadArgs
 */
export class ReadForceReloadArgs extends Message<ReadForceReloadArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadForceReloadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadForceReloadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadForceReloadArgs {
    return new ReadForceReloadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadForceReloadArgs {
    return new ReadForceReloadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadForceReloadArgs {
    return new ReadForceReloadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadForceReloadArgs | PlainMessage<ReadForceReloadArgs> | undefined, b: ReadForceReloadArgs | PlainMessage<ReadForceReloadArgs> | undefined): boolean {
    return proto3.util.equals(ReadForceReloadArgs, a, b);
  }
}

/**
 * UpdateForceReloadArgs メッセージ
 *
 * @generated from message service.UpdateForceReloadArgs
 */
export class UpdateForceReloadArgs extends Message<UpdateForceReloadArgs> {
  /**
   * @generated from field: repeated entity.ForceReload force_reloads = 1 [json_name = "force_reloads"];
   */
  forceReloads: ForceReload[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateForceReloadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateForceReloadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "force_reloads", jsonName: "force_reloads", kind: "message", T: ForceReload, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateForceReloadArgs {
    return new UpdateForceReloadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateForceReloadArgs {
    return new UpdateForceReloadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateForceReloadArgs {
    return new UpdateForceReloadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateForceReloadArgs | PlainMessage<UpdateForceReloadArgs> | undefined, b: UpdateForceReloadArgs | PlainMessage<UpdateForceReloadArgs> | undefined): boolean {
    return proto3.util.equals(UpdateForceReloadArgs, a, b);
  }
}

/**
 * DeleteForceReloadArgs メッセージ
 *
 * @generated from message service.DeleteForceReloadArgs
 */
export class DeleteForceReloadArgs extends Message<DeleteForceReloadArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteForceReloadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteForceReloadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteForceReloadArgs {
    return new DeleteForceReloadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteForceReloadArgs {
    return new DeleteForceReloadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteForceReloadArgs {
    return new DeleteForceReloadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteForceReloadArgs | PlainMessage<DeleteForceReloadArgs> | undefined, b: DeleteForceReloadArgs | PlainMessage<DeleteForceReloadArgs> | undefined): boolean {
    return proto3.util.equals(DeleteForceReloadArgs, a, b);
  }
}

/**
 * IndexForceReloadReply メッセージ
 *
 * @generated from message service.IndexForceReloadReply
 */
export class IndexForceReloadReply extends Message<IndexForceReloadReply> {
  /**
   * @generated from field: repeated entity.ForceReload force_reloads = 1 [json_name = "force_reloads"];
   */
  forceReloads: ForceReload[] = [];

  constructor(data?: PartialMessage<IndexForceReloadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexForceReloadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "force_reloads", jsonName: "force_reloads", kind: "message", T: ForceReload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexForceReloadReply {
    return new IndexForceReloadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexForceReloadReply {
    return new IndexForceReloadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexForceReloadReply {
    return new IndexForceReloadReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexForceReloadReply | PlainMessage<IndexForceReloadReply> | undefined, b: IndexForceReloadReply | PlainMessage<IndexForceReloadReply> | undefined): boolean {
    return proto3.util.equals(IndexForceReloadReply, a, b);
  }
}

/**
 * CreateForceReloadReply メッセージ
 *
 * @generated from message service.CreateForceReloadReply
 */
export class CreateForceReloadReply extends Message<CreateForceReloadReply> {
  constructor(data?: PartialMessage<CreateForceReloadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateForceReloadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateForceReloadReply {
    return new CreateForceReloadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateForceReloadReply {
    return new CreateForceReloadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateForceReloadReply {
    return new CreateForceReloadReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateForceReloadReply | PlainMessage<CreateForceReloadReply> | undefined, b: CreateForceReloadReply | PlainMessage<CreateForceReloadReply> | undefined): boolean {
    return proto3.util.equals(CreateForceReloadReply, a, b);
  }
}

/**
 * ReadForceReloadReply メッセージ
 *
 * @generated from message service.ReadForceReloadReply
 */
export class ReadForceReloadReply extends Message<ReadForceReloadReply> {
  /**
   * @generated from field: repeated entity.ForceReload force_reloads = 1 [json_name = "force_reloads"];
   */
  forceReloads: ForceReload[] = [];

  constructor(data?: PartialMessage<ReadForceReloadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadForceReloadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "force_reloads", jsonName: "force_reloads", kind: "message", T: ForceReload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadForceReloadReply {
    return new ReadForceReloadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadForceReloadReply {
    return new ReadForceReloadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadForceReloadReply {
    return new ReadForceReloadReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadForceReloadReply | PlainMessage<ReadForceReloadReply> | undefined, b: ReadForceReloadReply | PlainMessage<ReadForceReloadReply> | undefined): boolean {
    return proto3.util.equals(ReadForceReloadReply, a, b);
  }
}

/**
 * UpdateForceReloadReply メッセージ
 *
 * @generated from message service.UpdateForceReloadReply
 */
export class UpdateForceReloadReply extends Message<UpdateForceReloadReply> {
  constructor(data?: PartialMessage<UpdateForceReloadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateForceReloadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateForceReloadReply {
    return new UpdateForceReloadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateForceReloadReply {
    return new UpdateForceReloadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateForceReloadReply {
    return new UpdateForceReloadReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateForceReloadReply | PlainMessage<UpdateForceReloadReply> | undefined, b: UpdateForceReloadReply | PlainMessage<UpdateForceReloadReply> | undefined): boolean {
    return proto3.util.equals(UpdateForceReloadReply, a, b);
  }
}

/**
 * DeleteForceReloadReply メッセージ
 *
 * @generated from message service.DeleteForceReloadReply
 */
export class DeleteForceReloadReply extends Message<DeleteForceReloadReply> {
  constructor(data?: PartialMessage<DeleteForceReloadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteForceReloadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteForceReloadReply {
    return new DeleteForceReloadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteForceReloadReply {
    return new DeleteForceReloadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteForceReloadReply {
    return new DeleteForceReloadReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteForceReloadReply | PlainMessage<DeleteForceReloadReply> | undefined, b: DeleteForceReloadReply | PlainMessage<DeleteForceReloadReply> | undefined): boolean {
    return proto3.util.equals(DeleteForceReloadReply, a, b);
  }
}

